import { useEffect } from "react";
import { AuthProvider } from "./context/auth/AuthContext";
import { AppRouter } from "./routers/AppRoutes";
import './assets/styles/default.css';
import './assets/styles/lafise.css';
import './assets/styles/global.css';
import './assets/styles/swiftmart.css';
import './assets/styles/bancogeneral.css';
import './assets/styles/banistmo.css';
import './assets/styles/kinpos.css';
import { INSTANCE } from './utils/appConfig';

const App = () => {
  
  useEffect(() => {
    const company = process.env.REACT_APP_COMPANY ;
    let companyStyle;

    switch (company) {
      
      case 'global':
        companyStyle = 'global'; 
        break;  
      case 'lafise':
        companyStyle ='lafise'; 
        break; 
        case 'swiftmart':
          companyStyle ='swiftmart'; 
          break;    
      default:
        companyStyle ='default'; 
        break; 
    }
    // La clase de la instancia (ej. banistmo) sobrescribe la paleta de la empresa
    document.body.classList.add(companyStyle, INSTANCE);

    return () => {
      document.body.classList.remove(companyStyle, INSTANCE);
    };
  }, []);

  return(
  <AuthProvider>    
    <AppRouter/>
  </AuthProvider>
  
)

};


export default App;

